// SaleDeedDrafting.jsx

import React from "react";
import "../components/Styles/SaleDeedDrafting.css";

function SaleDeedDrafting() {
  return (
    <>
      {/* HERO SECTION */}

      <section className="hero-area">
        <div className="container">
          <div className="left-side">
            <div className="breadcrumb">
              <span>Home</span> / <span>Property</span> /{" "}
              <span>Sale Deed Drafting</span>
            </div>

            <div className="caption">
              <h1>Sale Deed Drafting</h1>

              <p className="hero-para">
                Sale Deed Drafting for your property with complete legal
                assistance and professional documentation support.
              </p>

              <div className="rating-star">
                <div className="rating-top">
                  <span className="rating-number">4.6</span>
                  <span className="reviews">(108 reviews)</span>
                </div>

                <div className="stars">★★★★★</div>

                <p className="purchase-text">289 People purchased</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT IS SALE DEED */}

      <section className="info-section">
        <div className="container">
          <div className="last-update">
            Last Updated: Mar 5, 2025
          </div>

          <h2>What is a sale deed?</h2>

          <p>
            A <strong>Sale Deed</strong> is an important legal document used in
            property transactions. It acts as final proof that ownership of the
            property has been transferred from the seller to the buyer.
          </p>

          <p>
            It contains details such as property location, size, price, buyer
            and seller details, and sale conditions. Once signed and registered,
            the buyer officially becomes the legal owner of the property.
          </p>
        </div>
      </section>

      {/* HOW IT WORKS */}

<section className="sale-how-section">
  <div className="container">

    <h2 className="sale-how-title">
      How it works?
    </h2>

    <div className="sale-how-grid">

      <div className="sale-how-box">

        <div className="sale-how-icon">📄</div>

        <h3>Property document collection</h3>

        <p>
          All the property papers can be uploaded or hard copies can be
          collected.
        </p>

      </div>

      <div className="sale-how-box">

        <div className="sale-how-icon">🔍</div>

        <h3>Review & Analysis</h3>

        <p>
          Senior Property Lawyer will analyse and prepare detailed report.
        </p>

      </div>

      <div className="sale-how-box">

        <div className="sale-how-icon">📞</div>

        <h3>Detailed consultation</h3>

        <p>
          Consultation call with senior property lawyer to discuss report.
        </p>

      </div>

      <div className="sale-how-box">

        <div className="sale-how-icon">✅</div>

        <h3>Delivery</h3>

        <p>
          Your detailed property verification report will be delivered in
          5 days.
        </p>

      </div>

    </div>

  </div>
</section>

      {/* PROPERTY DESCRIPTION */}

      <section className="description-section">
        <div className="container">

          {/* Drafting Process */}

          <div className="content-box">
            <h2>Drafting Process</h2>

            <p>
              <strong>STEP 1:</strong> Understanding property details and
              requirements.
            </p>

            <p>
              <strong>STEP 2:</strong> Lawyer will draft your Sale Deed after
              discussion.
            </p>

            <p>
              <strong>STEP 3:</strong> Printing of Sale Agreement on
              non-judicial stamp paper as per state law.
            </p>
          </div>

          {/* Why LegalAxis */}

          <div className="content-box">
            <h2>Why LegalAxis</h2>

            <ul>
              <li>
                Senior Expert Property Lawyers for drafting and reviewing.
              </li>

              <li>
                High customer satisfaction with trusted legal support.
              </li>

              <li>
                Responsible delivery with smooth lawyer interaction.
              </li>
            </ul>
          </div>

          {/* Deliverables */}

          <div className="content-box">
            <h2>Deliverables</h2>

            <ul>
              <li>30 Minutes consultation with property lawyer.</li>

              <li>First draft delivered within 2 working days.</li>

              <li>2 free iterations after first draft delivery.</li>

              <li>Registration assistance by senior expert lawyer.</li>
            </ul>
          </div>

          {/* Why Sale Deed Important */}

          <div className="content-box">
            <h2>Why a good sale deed is critical for your property?</h2>

            <ol>
              <li>Legal proof of property ownership transfer.</li>

              <li>Clear sale terms and payment conditions.</li>

              <li>Detailed property description and boundaries.</li>

              <li>Protection against future legal disputes.</li>

              <li>Compliance with statutory requirements.</li>

              <li>Clear title and encumbrance details.</li>

              <li>Proper registration and stamp duty compliance.</li>
            </ol>
          </div>
        </div>
      </section>

      {/* CHAT SECTION */}

<section className="sale-chat-section">

  <div className="container">

    <div className="sale-chat-panel">

      <div className="sale-chat-left">

        <h2>Chat with us</h2>

        <h3>Before you Buy your Property.</h3>

      </div>

      <div className="sale-chat-right">

        <a
          href="https://api.whatsapp.com/send?phone=918743940556"
          target="_blank"
          rel="noreferrer"
        >
          Chat Now
        </a>

      </div>

    </div>

  </div>

</section>

      {/* OTHER PRODUCTS */}

      <section className="products-section">
        <div className="container">
          <h2>Check out other Property Products</h2>

          <div className="products-grid">

            <div className="product-box">
              <h3>Property Report</h3>

              <ul>
                <li>Best drafting in India</li>
                <li>Faster Turn Around Time</li>
                <li>Best price</li>
              </ul>

              <div className="product-footer">
                <span>₹ 5999</span>

                <button>Explore</button>
              </div>
            </div>

            <div className="product-box">
              <h3>Property Registration</h3>

              <ul>
                <li>Best drafting in India</li>
                <li>Faster Turn Around Time</li>
                <li>Best price</li>
              </ul>

              <div className="product-footer">
                <span>₹ 16999</span>

                <button>Explore</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VIRTUAL SECTION */}

      <section className="virtual-section">
        <div className="container">
          <h2>All property legal solutions under one roof</h2>

          <p>
            With more than 35000 verified properties LegalAxis offers the most
            reliable property legal service.
          </p>
        </div>
      </section>

      {/* ONLINE SECTION */}

      <section className="online-section">
        <div className="container">
          <div className="online-grid">

            <div className="online-box">
              <h3>35K+ Properties</h3>

              <p>
                More than 35000 verified properties with trusted services.
              </p>
            </div>

            <div className="online-box">
              <h3>All in One Solution</h3>

              <p>
                Property verification, drafting and registration under one roof.
              </p>
            </div>

            <div className="online-box">
              <h3>Trusted in 80 countries</h3>

              <p>
                Indians across the world trust LegalAxis for property matters.
              </p>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default SaleDeedDrafting;